import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import collegeReducer from "./slices/collegeSlice";
import studentReducer from "./slices/studentSlice";
import feeReducer from "./slices/feeSlice";
import usersReducer from "./slices/usersSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    college: collegeReducer,
    student: studentReducer,
    fee: feeReducer,
    users: usersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
